import { AppState } from "../state";

export function exportAppErase(state: AppState): AppState {
    const { exportContent, ...cleanState } = state;

    return cleanState;
}
